var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: {
        form: _vm.form,
        width: "800px",
        "label-width": "120px",
        "confirm-button-text": _vm.isView ? "" : _vm.$t("okText"),
      },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "BjDivider",
        [
          _vm._v(_vm._s(_vm.$t("AccountManagement.work.fill")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              _vm.isView
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          return _vm.discardPlanData()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("discardText")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("AccountManagement.work.staffSelect"),
                prop: "staffList",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: {
                  "option-list": _vm.staffDeptList,
                  placeholder: _vm.$t("AccountManagement.work.staffSelect"),
                  multiple: "",
                  disabled: _vm.isView,
                },
                model: {
                  value: _vm.staffList,
                  callback: function ($$v) {
                    _vm.staffList = $$v
                  },
                  expression: "staffList",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isShowReason
        ? _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("AccountManagement.work.ReasonTitle"))),
          ])
        : _vm._e(),
      _vm.isShowReason
        ? _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("AccountManagement.work.enterReason"),
                    prop: "remark",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      type: "textarea",
                      "show-word-limit": "",
                      maxlength: _vm.MAX_LENGTH.PRIORITY,
                      autosize: "",
                      placeholder: _vm.$t("AccountManagement.work.ReasonTitle"),
                      clearable: "",
                      disabled: _vm.isView,
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }